import { render, staticRenderFns } from "./CheckTermsAndConditions.vue?vue&type=template&id=0fbfd230&"
import script from "./CheckTermsAndConditions.vue?vue&type=script&lang=js&"
export * from "./CheckTermsAndConditions.vue?vue&type=script&lang=js&"
import style0 from "./CheckTermsAndConditions.vue?vue&type=style&index=0&id=0fbfd230&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports